// Mock data for Lavoir des Remparts - Version 4.0 Premium

export const laverieInfo = {
  name: "Lavoir des Remparts",
  tagline: "Laverie 3.0",
  slogan: "Votre linge propre et sec en 1 heure",
  address: "5 Rue Tour de Sault",
  city: "64100 Bayonne",
  phone: "06 20 25 47 39",
  email: "laverie64100@gmail.com",
  instagram: "@lavoir_des_remparts",
  instagramUrl: "https://instagram.com/lavoir_des_remparts",
  hours: {
    open: "07:00",
    close: "21:30",
    days: "7j/7"
  },
  googleMapsUrl: "https://maps.google.com/?q=5+Rue+Tour+de+Sault,+64100+Bayonne"
};

// Tarifs exacts recopiés du panneau TARIFS DES SERVICES
export const tarifs = {
  lavage: [
    { capacity: "6,5 kg", price: "5,50€" },
    { capacity: "14 kg", price: "9,50€" }
  ],
  sechage: [
    { capacity: "13 kg", price: "1,50€" },
    { capacity: "16 kg", price: "2,00€" }
  ],
  mention: "La lessive et l'adoucissant sont offerts à chaque lavage"
};

// Marchés/Secteurs avec détails complets
export const marches = [
  {
    id: "hotels",
    title: "Hôtels & Hébergements",
    shortDesc: "Draps, serviettes, linge de maison en grande quantité",
    icon: "hotel",
    image: "https://customer-assets.emergentagent.com/job_smart-laverie/artifacts/mk7fqrnl_IMG-20260114-WA0019.jpg",
    color: "#9B1B30",
    details: {
      intro: "Offrez à vos clients un linge impeccable et professionnel. Notre laverie est conçue pour répondre aux exigences des établissements hôteliers.",
      pourquoi: [
        "Machines grande capacité 14kg idéales pour les draps et serviettes",
        "Lavage rapide en 31 minutes - optimisez votre rotation",
        "Lessive & Adoucissant OFFERTS à chaque lavage",
        "Disponible 7j/7 de 7h à 21h30"
      ],
      avantages: [
        "Réductions jusqu'à 30% selon le volume",
        "Facturation électronique pour récupération TVA",
        "Tarifs préférentiels pour partenariats long terme",
        "Pas d'investissement en machines à laver"
      ],
      testimonial: "La solution idéale pour gérer le linge de nos 12 chambres sans investissement.",
      author: "Mikel Etcheverry"
    }
  },
  {
    id: "restaurants",
    title: "Restaurants & Traiteurs",
    shortDesc: "Nappes, torchons, tabliers toujours impeccables",
    icon: "restaurant",
    image: "https://customer-assets.emergentagent.com/job_smart-laverie/artifacts/5x3eilna_IMG-20260114-WA0022.jpg",
    color: "#006633",
    details: {
      intro: "L'hygiène est primordiale dans la restauration. Garantissez un linge parfaitement propre à vos clients avec notre service professionnel.",
      pourquoi: [
        "Lessive de qualité professionnelle anti-taches incluse",
        "Lessive & Adoucissant OFFERTS pour un linge doux",
        "Cycles intensifs pour éliminer les taches de graisse",
        "Séchage rapide ~25 min pour une rotation optimale"
      ],
      avantages: [
        "Réductions automatiques pour les professionnels",
        "Factures numérisées pour comptabilité simplifiée",
        "Économisez sur l'achat et l'entretien de machines",
        "Horaires étendus adaptés à la restauration"
      ],
      testimonial: "Nos nappes blanches n'ont jamais été aussi propres. Service au top !",
      author: "Sophie Martin"
    }
  },
  {
    id: "airbnb",
    title: "Airbnb & Conciergeries",
    shortDesc: "Gestion optimisée du linge locatif",
    icon: "airbnb",
    image: "https://customer-assets.emergentagent.com/job_smart-laverie/artifacts/69spqi25_IMG-20260114-WA0020.jpg",
    color: "#9B1B30",
    details: {
      intro: "Gérez efficacement le linge de vos locations saisonnières. Solution idéale pour les conciergeries et propriétaires multi-biens.",
      pourquoi: [
        "Lavage + séchage en 1h entre deux réservations",
        "Machines disponibles 7j/7, même les jours fériés",
        "Grande capacité pour draps, housses et serviettes",
        "Lessive & Adoucissant OFFERTS pour un linge parfumé et doux"
      ],
      avantages: [
        "Partenariat été 2026 : tarifs préférentiels",
        "Réductions jusqu'à 25% pour conciergeries",
        "Facturation mensuelle possible",
        "Point relais Pickup sur place pour vos colis"
      ],
      testimonial: "Indispensable pour gérer mes 5 appartements. Gain de temps énorme !",
      author: "Julien Larralde"
    }
  },
  {
    id: "spas",
    title: "Spas & Salons de Beauté",
    shortDesc: "Serviettes, peignoirs, draps de massage",
    icon: "spa",
    image: "https://customer-assets.emergentagent.com/job_smart-laverie/artifacts/ycrpu4nf_IMG-20260114-WA0025.jpg",
    color: "#006633",
    details: {
      intro: "Dans le domaine du bien-être, la qualité du linge reflète votre professionnalisme. Offrez à vos clients une expérience sensorielle parfaite.",
      pourquoi: [
        "Lessive & Adoucissant OFFERTS - parfait pour peaux sensibles",
        "Lessive éco-responsable sans résidu chimique",
        "Produits hypoallergéniques de qualité professionnelle",
        "Cycles adaptés aux textiles délicats"
      ],
      avantages: [
        "Réductions professionnelles automatiques",
        "Facturation électronique disponible",
        "Linge doux et parfumé pour vos clients",
        "Proximité centre-ville de Bayonne"
      ],
      testimonial: "Mes clientes remarquent la douceur des serviettes. Excellent service !",
      author: "Isabelle Dupont"
    }
  },
  {
    id: "sport",
    title: "Clubs Sportifs & Fitness",
    shortDesc: "Équipements, serviettes, tenues de sport",
    icon: "sport",
    image: "https://customer-assets.emergentagent.com/job_smart-laverie/artifacts/so8fruzf_IMG-20260114-WA0021.jpg",
    color: "#9B1B30",
    details: {
      intro: "Les installations sportives génèrent un volume important de linge. Notre laverie offre la capacité et la rapidité dont vous avez besoin.",
      pourquoi: [
        "Machines grande capacité 14kg pour gros volumes",
        "Cycles de lavage rapides et efficaces",
        "Lessive anti-odeurs performante incluse",
        "Disponibilité 7j/7 adaptée aux plannings sportifs"
      ],
      avantages: [
        "Réductions volume jusqu'à 20%",
        "Idéal pour clubs de rugby, pelote basque, surf...",
        "Séchage rapide entre les entraînements",
        "Facturation adaptée aux associations"
      ],
      testimonial: "Solution parfaite pour notre club de rugby. Économique et efficace.",
      author: "Xabi Aguirre"
    }
  },
  {
    id: "particuliers",
    title: "Particuliers & Familles",
    shortDesc: "Couettes, rideaux, linge du quotidien",
    icon: "home",
    image: "https://customer-assets.emergentagent.com/job_9a62e9ab-f3c7-42e1-9076-76243336471d/artifacts/hha95i9f_IMG-20251203-WA0005.jpg",
    color: "#006633",
    details: {
      intro: "Votre machine à laver ne peut pas tout faire. Pour les couettes, rideaux et gros volumes, notre laverie est la solution idéale.",
      pourquoi: [
        "Machines jusqu'à 14kg pour couettes et rideaux",
        "Lessive & Adoucissant OFFERTS à chaque lavage",
        "Produits hypoallergéniques, idéaux pour les enfants",
        "Linge propre et sec en seulement 1 heure"
      ],
      avantages: [
        "Prix attractifs à partir de 5,50€",
        "Programme fidélité via l'app : jusqu'à -10%",
        "Sièges confortables, café et confiseries",
        "Point relais Pickup pour vos colis"
      ],
      testimonial: "Enfin une solution pour laver ma couette 2 personnes !",
      author: "Marie-Claire Dubois"
    }
  },
  {
    id: "etudiants",
    title: "Étudiants",
    shortDesc: "Solution économique proche du campus",
    icon: "student",
    image: "https://customer-assets.emergentagent.com/job_smart-laverie/artifacts/19rar2lb_IMG-20260114-WA0023.jpg",
    color: "#9B1B30",
    details: {
      intro: "Étudiant à Bayonne ? Notre laverie est la solution économique et pratique pour garder ton linge propre sans te ruiner.",
      pourquoi: [
        "Tarifs étudiants à partir de 5,50€ seulement",
        "Lessive & Adoucissant OFFERTS - économie garantie",
        "Lavage + séchage en 1h - optimise ton temps",
        "Sièges, café et confiseries pendant l'attente"
      ],
      avantages: [
        "Programme fidélité : -10% via l'app",
        "Point Pickup pour tes colis Vinted",
        "Ouvert 7j/7 même le dimanche",
        "À deux pas du centre-ville"
      ],
      testimonial: "Super pratique entre les cours, et le prix est imbattable !",
      author: "Lucas Bernier"
    }
  },
  {
    id: "sante",
    title: "Établissements de Santé",
    shortDesc: "Cabinets médicaux, EHPAD, professions libérales",
    icon: "health",
    image: "https://customer-assets.emergentagent.com/job_smart-laverie/artifacts/5zh5xn4o_IMG-20260114-WA0026.jpg",
    color: "#006633",
    details: {
      intro: "L'hygiène est cruciale dans le domaine de la santé. Notre laverie garantit un linge parfaitement propre et désinfecté.",
      pourquoi: [
        "Lessive désinfectante professionnelle incluse",
        "Cycles haute température disponibles",
        "Produits hypoallergéniques de qualité médicale",
        "Machines entretenues régulièrement"
      ],
      avantages: [
        "Facturation électronique pour comptabilité",
        "Réductions professionnels de santé",
        "Confidentialité et discrétion assurées",
        "Horaires étendus 7h-21h30"
      ],
      testimonial: "Parfait pour les blouses et draps de mon cabinet médical.",
      author: "Dr. Amaia Iturria"
    }
  }
];

export const features = [
  {
    id: 1,
    title: "Linge Prêt en 1h",
    description: "Lavage 31 min + séchage ~25 min. Votre linge propre et sec en une heure chrono !",
    icon: "clock"
  },
  {
    id: 2,
    title: "Lessive & Adoucissant OFFERTS",
    description: "Lessive et adoucissant de qualité offerts à chaque lavage. Votre linge propre et doux sans supplément !",
    icon: "gift"
  },
  {
    id: 3,
    title: "Espace Confort",
    description: "Sièges confortables, distributeurs de boissons et confiseries. Détendez-vous pendant que vos machines tournent !",
    icon: "coffee"
  },
  {
    id: 4,
    title: "Réductions Pro -30%",
    description: "Tarifs préférentiels pour les professionnels selon le volume. Plus vous lavez, plus vous économisez !",
    icon: "percent"
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_smart-laverie/artifacts/so8fruzf_IMG-20260114-WA0021.jpg",
    alt: "Vue panoramique de la laverie"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_remparts-laundry/artifacts/xikwc9sb_IMG-20251203-WA0002%281%29.jpg",
    alt: "Sièges confortables et borne de paiement"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_remparts-laundry/artifacts/vo7c4ajv_IMG-20251203-WA0004%281%29.jpg",
    alt: "Machine à café et distributeur de confiseries"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_smart-laverie/artifacts/ycrpu4nf_IMG-20260114-WA0025.jpg",
    alt: "Machines à laver professionnelles"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_smart-laverie/artifacts/mk7fqrnl_IMG-20260114-WA0019.jpg",
    alt: "Espace lavage grande capacité"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_smart-laverie/artifacts/5zh5xn4o_IMG-20260114-WA0026.jpg",
    alt: "Point Pickup Chronopost Colissimo DPD"
  },
  {
    id: 7,
    url: "https://customer-assets.emergentagent.com/job_smart-laverie/artifacts/5x3eilna_IMG-20260114-WA0022.jpg",
    alt: "Espace laverie moderne"
  },
  {
    id: 8,
    url: "https://customer-assets.emergentagent.com/job_9a62e9ab-f3c7-42e1-9076-76243336471d/artifacts/hha95i9f_IMG-20251203-WA0005.jpg",
    alt: "Borne de paiement écran tactile"
  },
  {
    id: 9,
    url: "https://customer-assets.emergentagent.com/job_smart-laverie/artifacts/19rar2lb_IMG-20260114-WA0023.jpg",
    alt: "Vue d'ensemble laverie"
  },
  {
    id: 10,
    url: "https://customer-assets.emergentagent.com/job_smart-laverie/artifacts/69spqi25_IMG-20260114-WA0020.jpg",
    alt: "Espace laverie et point relais"
  }
];

export const heroImage = "https://customer-assets.emergentagent.com/job_smart-laverie/artifacts/69spqi25_IMG-20260114-WA0020.jpg";
export const paymentImage = "https://customer-assets.emergentagent.com/job_9a62e9ab-f3c7-42e1-9076-76243336471d/artifacts/hha95i9f_IMG-20251203-WA0005.jpg";
